export default {
    empleados: [],
    empleadosFiltros: [],
    departments: [],
    totalPersonal: 0,
    empleadosExport: [],
    empleadosFiltersExport: [],
}